import { createSelector } from 'reselect';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { createOkvedSelectOption } from '../common/createOkvedSelectOption';
import { getRegistryOkvedItemKey } from '../common/getRegistryOkvedItemKey';
import { IRegistryExportOkvedFilterParams } from '../interfaces/IRegistryExportOkvedFilterParams';

export const getRegistryExportOkvedItem = (state: IRootState, filterParams: IRegistryExportOkvedFilterParams) => {
  return state.registry.okved[getRegistryOkvedItemKey(filterParams.inn, filterParams.ogrn)];
};
export const getRegistryExportOkvedItemData = (state: IRootState, filterParams: IRegistryExportOkvedFilterParams) => {
  const registryExportOkvedItem = getRegistryExportOkvedItem(state, filterParams);

  return registryExportOkvedItem?.data;
};
export const getRegistryExportOkvedItemStatus = (state: IRootState, filterParams: IRegistryExportOkvedFilterParams) => {
  const registryExportOkvedItem = getRegistryExportOkvedItem(state, filterParams);

  return registryExportOkvedItem?.status;
};
export const makeGetRegistryExportOkvedItemSelectOptions = () => {
  return createSelector(
    (state: IRootState, filterParams: IRegistryExportOkvedFilterParams) =>
      getRegistryExportOkvedItemData(state, filterParams),
    data => data?.map(item => createOkvedSelectOption(item)),
  );
};
